import {USER_ROOT_API_URL} from "../../../../config/settings.js"

export const CHECK_IF_BLOCKED = USER_ROOT_API_URL +  "/check_if_blocked"
export const GET_FRIENDPAGE_INFORMATION = USER_ROOT_API_URL +  "/get_user_basic_information"
export const GET_FRIENDPAGE_FRIENDS = USER_ROOT_API_URL +  "/get_user_random_friends"
export const GET_FRIENDPAGE_POSTS = USER_ROOT_API_URL +  "/get_friend_user_posts"
export const DO_BLOCK_USER = USER_ROOT_API_URL +  "/block_user"
export const DO_UNBLOCK_USER = USER_ROOT_API_URL +  "/unblock_user"
export const DO_REMOVE_FRIEND = USER_ROOT_API_URL +  "/remove_friend"